import TourPreview from "./TourPreview";

export default TourPreview;
